import React from 'react'
import PropTypes from 'prop-types'
import {Box, Button, Text, useMultiStyleConfig} from '@chakra-ui/react'
import {FormattedMessage} from 'react-intl'
import {FiltersIcon} from '../../../components/icons/others'

const FiltersButton = ({buttonClick}) => {
    const styles = useMultiStyleConfig('Filters')

    return (
        <Button
            rightIcon={<FiltersIcon {...styles.filterIcon} />}
            {...styles.filterButton}
            {...styles.filtersButtonSpecific}
            onClick={buttonClick}
        >
            <Text {...styles.filterText}>
                <Box as="span" {...styles.mobile}>
                    <FormattedMessage defaultMessage="Filter" id="product_list.button.filter" />
                </Box>
                <Box as="span" {...styles.desktop}>
                    <FormattedMessage
                        defaultMessage="All Filters"
                        id="product_list.button.all_filters"
                    />
                </Box>
            </Text>
        </Button>
    )
}
FiltersButton.propTypes = {
    buttonClick: PropTypes.func,
}

export default FiltersButton
